import { render } from "./TextRenderer.vue?vue&type=template&id=6533bc76"
import script from "./TextRenderer.vue?vue&type=script&lang=ts"
export * from "./TextRenderer.vue?vue&type=script&lang=ts"
script.render = render

export default script